export { default, StyledAvatar } from './Avatar';
export type { AvatarProps } from './Avatar';
